import React from "react";

/**
 * @component RecurringCheckmarkIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <RecurringCheckmarkIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const RecurringCheckmarkIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="RecurringCheckmarkIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M5.014 12a6.944 6.944 0 001.826 4.73l.21.22a7 7 0 009.727.167l.173-.167-1.414-1.414 4.871-.63-.629 4.872-1.414-1.414a9 9 0 01-12.728 0 8.891 8.891 0 01-2.498-4.788A9.017 9.017 0 013 12.01h.006V12h2.008zm10.593-2.293a1 1 0 010 1.414l-3.657 3.657a1 1 0 01-1.414 0L8.707 12.95a1 1 0 011.414-1.414l1.12 1.12 2.951-2.949a1 1 0 011.415 0zm-3.246-6.7c2.1.084 4.175.898 5.813 2.444l.19.185.225.234.096.104.118.133a8.861 8.861 0 012.04 4.216l.043.25c.071.44.109.886.113 1.332h-.006l.001.095h-2.008a6.955 6.955 0 00-1.245-4.005l-.186-.254-.094-.12a7 7 0 00-10.238-.737l-.173.166 1.414 1.414-4.871.63.629-4.872 1.414 1.414a8.976 8.976 0 016.725-2.629z"
        fillRule="evenodd"
      />
    </svg>
  )
);
RecurringCheckmarkIcon.displayName = "RecurringCheckmarkIcon";
export default RecurringCheckmarkIcon;
